import axios from "@/api/axios";

async function getDoctorSettings(doctorId, patientId) {
  console.log("getDoctorSettings", doctorId);

  try {
    let url = "/api/cloud/getDoctorSettings";
    let requestData = {
      doctorId: doctorId,
      patientId: patientId,
      s3Url: vueApp.s3Url,
      isStaging: !!vueApp.isStaging,
    };
    const response = await axios.get(url, { params: requestData });
    const responseData = response.data;
    return responseData;
  } catch (e) {
    console.log("getDoctorSettings error", e);
  }
}

async function getPanoramicImgUrl(patientId) {
  console.log("getPanoramicImgUrl", patientId);
  if (!patientId) patientId = vueApp.patientId;

  try {
    let url = "/api/cloud/getPanoramicImgUrl";
    let requestData = {
      patientId: patientId,
      isStaging: !!vueApp.isStaging,
    };
    const response = await axios.get(url, { params: requestData });
    const responseData = response.data;
    return responseData.value;
  } catch (e) {
    console.log("getPanoramicImgUrl error", e);
  }
}

export { getDoctorSettings, getPanoramicImgUrl };
